import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import USERS from '../../common/data/userDummyData';
import {
    DropdownItem,
    DropdownMenu,
} from '../../components/bootstrap/Dropdown';
import Button from '../../components/bootstrap/Button';
import Collapse from '../../components/bootstrap/Collapse';
import { NavigationLine } from '../Navigation/Navigation';
import Icon from '../../components/icon/Icon';
import Modal, {
    ModalBody,
    ModalHeader,
    ModalTitle,
} from '../../components/bootstrap/Modal';
import ConnectProfile from '../../pages/ConnectProfile';

const User = () => {
    const navigate = useNavigate();

    const [collapseStatus, setCollapseStatus] = useState<boolean>(false);

    const { t } = useTranslation(['translation', 'menu']);

    const [connectProfileModal, setConnectProfileModal] = useState(false);

    return (
        <>
            <div
                className={classNames('user', { open: collapseStatus })}
                role='presentation'
                onClick={() => setCollapseStatus(!collapseStatus)}>
                <div className='user-avatar'>
                    <img
                        srcSet={USERS.JOHN.srcSet}
                        src={USERS.JOHN.src}
                        alt='Avatar'
                        width={128}
                        height={128}
                    />
                </div>
                <div className='user-info'>
                    <div className='user-name d-flex align-items-center'>
                        {`${USERS.JOHN.name} ${USERS.JOHN.surname}`}
                        <Icon icon='Verified' className='ms-1' color='info' />
                    </div>
                    <div className='user-sub-title'>{USERS.JOHN.position}</div>
                </div>
            </div>
            <DropdownMenu>
                <DropdownItem>
                    <Button icon='AccountBox'>Profile</Button>
                </DropdownItem>
            </DropdownMenu>

            <Collapse isOpen={collapseStatus} className='user-menu'>
                <nav aria-label='aside-bottom-user-menu'>
                    <div className='navigation'>
                        <div
                            role='presentation'
                            onClick={() =>
                                setConnectProfileModal(!connectProfileModal)
                            }
                            className='navigation-item cursor-pointer'>
                            <span className='navigation-link navigation-link-pill'>
                                <span className='navigation-link-info'>
                                    <Icon
                                        icon='AddBox'
                                        className='navigation-icon'
                                    />
                                    <span className='navigation-text'>
                                        {t('Connect Profile')}
                                    </span>
                                </span>
                            </span>
                        </div>
                        <Modal
                            id='connect-profile-modal'
                            isCentered={true}
                            isOpen={connectProfileModal}
                            size='lg'
                            setIsOpen={() =>
                                setConnectProfileModal(!connectProfileModal)
                            }
                            titleId='connect-profile-title'>
                            <ModalHeader className='connect-profile-header'>
                                <ModalTitle
                                    className='connect-profile'
                                    id='connect-profile'>
                                    Connect a Profile
                                </ModalTitle>
                                <Button
                                    color='primary'
                                    isOutline
                                    onClick={() =>
                                        setConnectProfileModal(
                                            !connectProfileModal,
                                        )
                                    }>
                                    Close
                                </Button>
                            </ModalHeader>
                            <ModalBody className='connect-profile-body'>
                                <h5>Select a network to connect a profile.</h5>
                                <p>
                                    If you have several accounts to connect,
                                    don’t worry—you can navigate back to this
                                    screen after each profile is set up.
                                </p>
                                <div className='mt-4'>
                                    <ConnectProfile />
                                </div>
                            </ModalBody>
                        </Modal>
                    </div>
                </nav>
                <nav aria-label='aside-bottom-user-menu'>
                    <div className='navigation'>
                        <div
                            role='presentation'
                            onClick={() => navigate(`../profile`)}
                            className='navigation-item cursor-pointer'>
                            <span className='navigation-link navigation-link-pill'>
                                <span className='navigation-link-info'>
                                    <Icon
                                        icon='AccountBox'
                                        className='navigation-icon'
                                    />
                                    <span className='navigation-text'>
                                        {t('Profile')}
                                    </span>
                                </span>
                            </span>
                        </div>
                    </div>
                </nav>
                <nav aria-label='aside-bottom-user-menu'>
                    <div className='navigation'>
                        <div
                            role='presentation'
                            onClick={() => navigate(`../profile`)}
                            className='navigation-item cursor-pointer'>
                            <span className='navigation-link navigation-link-pill'>
                                <span className='navigation-link-info'>
                                    <Icon
                                        icon='CreditCard'
                                        className='navigation-icon'
                                    />
                                    <span className='navigation-text'>
                                        {t('Billing')}
                                    </span>
                                </span>
                            </span>
                        </div>
                    </div>
                </nav>
                <NavigationLine />
                <nav aria-label='aside-bottom-user-menu-2'>
                    <div className='navigation'>
                        <div
                            role='presentation'
                            className='navigation-item cursor-pointer'
                            onClick={() => navigate(`../login`)}>
                            <span className='navigation-link navigation-link-pill'>
                                <span className='navigation-link-info'>
                                    <Icon
                                        icon='Logout'
                                        className='navigation-icon'
                                    />
                                    <span className='navigation-text'>
                                        {t('Logout')}
                                    </span>
                                </span>
                            </span>
                        </div>
                    </div>
                </nav>
            </Collapse>
        </>
    );
};

export default User;
